import { Image } from 'antd';
import styled from 'styled-components';

export const Img = styled(Image)`
	padding-left: 25px;
	height: auto;
	width: 180px;

	@media (max-width: 700px) {
		width: 80%;
		max-width: 150px;
	}
`;
